export default __webpack_public_path__ + "static/media/logo-lg.53581a3b.af390787.png";